import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FaFacebookF } from 'react-icons/fa';
import { A, H1, P } from 'components/Typography';
import Button from 'components/Button';
import FadeInImage from 'components/FadeInImage';
import BabyBird from 'products/global/assets/img/nest/contributor/level2.png';
import TrustpilotLogo from 'products/global/assets/img/logos/trustpilot.svg';
import history from 'routing/history';
import { setNPSSubmitted } from '../state';
import { ThanksContainer, LeftCol, ReviewLogo, Buttons, ImageContainer } from './styled';

const Thanks = ({ profilePath, campaign }) => {
  const dispatch = useDispatch();

  return (
    <ThanksContainer>
      <LeftCol>
        <H1>Thank you for being a SafetyWing contributor!</H1>
        <P>
          Congrats, your Contributor egg has now hatched into a beautiful baby bird! Help
          your bird grow by answering the feedback survey we’ll send to your email. As
          thanks, we’ll also ship you a SafetyWing-branded premium black-out eye mask.
        </P>
        <P>
          {campaign !== 'claims_ni' &&
            `We also appreciate reviews on TrustPilot and Facebook.`}{' '}
          Thanks for your help! Be sure to keep in touch through our Instagram{' '}
          <A
            variant="dark"
            href="https://www.instagram.com/safetywing/?hl=en"
            target="_blank"
          >
            (@nomadcities)
          </A>
          .
        </P>
        <Buttons>
          {campaign !== 'claims_ni' && (
            <>
              <Button
                variant="secondary"
                onClick={() =>
                  window.open(
                    'https://www.trustpilot.com/evaluate/safetywing.com',
                    '_blank',
                    'noopener'
                  )
                }
              >
                <ReviewLogo src={TrustpilotLogo} alt="trustpilot logo" />
                Leave review on Trustpilot
              </Button>
              <Button
                variant="secondary"
                onClick={() =>
                  window.open(
                    'https://www.facebook.com/safetywing/reviews/',
                    '_blank',
                    'noopener'
                  )
                }
              >
                <FaFacebookF />
                Leave review on Facebook
              </Button>
            </>
          )}
          <Button
            variant="primary"
            onClick={() => {
              dispatch(setNPSSubmitted(false));
              history.push(profilePath);
            }}
          >
            Go to my profile
          </Button>
        </Buttons>
      </LeftCol>
      <ImageContainer>
        <FadeInImage src={BabyBird} />
      </ImageContainer>
    </ThanksContainer>
  );
};

Thanks.propTypes = {
  profilePath: PropTypes.string.isRequired,
  campaign: PropTypes.string.isRequired
};

export default Thanks;
